import { render } from "./CopyMenuModal.vue?vue&type=template&id=75b59ad3&scoped=true"
import script from "./CopyMenuModal.vue?vue&type=script&lang=ts"
export * from "./CopyMenuModal.vue?vue&type=script&lang=ts"

import "./CopyMenuModal.vue?vue&type=style&index=0&id=75b59ad3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75b59ad3"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QIcon,QSeparator,QInput,QSpace});
